import { FormDialog, TooltipProvider } from "@capacit-com/lara-law-shared-ui";
import Prompt from "@/models/prompt/prompt";
import { FC, useState } from "react";
import ReviewPromptDialogContent from "./ReviewPromptDialogContent";
import EditPromptForm from "./EditPromptForm";

type Props = {
  prompt: Prompt;
  isOpen: boolean;
  onOpenChange: (isOpen: boolean) => void;
};

const ReviewPromptDialog: FC<Props> = ({ prompt, isOpen, onOpenChange }) => {
  const [isEditing, setIsEditing] = useState(false);
  const [formHasChanged, setFormHasChanged] = useState(false);

  const onEditPress = () => setIsEditing(true);

  const handleClose = () => {
    setIsEditing(false);
    setFormHasChanged(false);
    onOpenChange(false);
  };

  const handleBack = () => {
    setIsEditing(false);
    setFormHasChanged(false);
  };

  return (
    <TooltipProvider>
      <FormDialog
        open={isOpen}
        onOpenChange={(next) => (next ? onOpenChange(true) : handleClose())}
        isDirty={isEditing && formHasChanged}
        size="lg"
        className="min-h-[75vh]"
      >
        {isEditing ? (
          <EditPromptForm
            selectedPrompt={prompt}
            handleBack={handleBack}
            setFormHasChanged={setFormHasChanged}
          />
        ) : (
          <ReviewPromptDialogContent
            prompt={prompt}
            onEdit={onEditPress}
            handleClose={handleClose}
          />
        )}
      </FormDialog>
    </TooltipProvider>
  );
};

export default ReviewPromptDialog;
